<template>
  <div>
    <div
      class="sub-menu-item"
      v-for="menu in filteredMenus"
      :key="menu.uri"
      :class="{
        show: defaultRoute.menu === menu.uri,
        showMobile: defaultRoute.menuMobile === menu.uri,
      }"
    >
      <b-container class="sub-menu-container">
        <ul>
          <li v-for="item in menu.children" :key="item.uri">
            <a
              :href="link(menu.uri, item.uri, !!item.frontendv2)"
              v-if="!item.dropdown"
              @click="
                handleSelectMenu({
                  menu: menu.uri,
                  submenu: item.uri,
                  v2: !!item.frontendv2,
                })
              "
              :class="defaultRoute.submenu === item.uri ? 'active' : ''"
            >
              {{ item.name }}
            </a>
            <NavbarSubMenuDropDown :menu="item" v-else></NavbarSubMenuDropDown>
          </li>
        </ul>
      </b-container>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import NavbarSubMenuDropDown from './NavbarSubMenuDropDown';
import NavbarMixin from './NavbarMixin';

export default {
  name: 'NavbarSubMenu',
  mixins: [NavbarMixin],
  components: {
    NavbarSubMenuDropDown,
  },
  computed: {
    ...mapState('application', ['defaultRoute']),
    ...mapGetters('application', ['filteredMenus']),
  },
  methods: {
    ...mapActions('application', ['handleSelectMenu']),
  },
};
</script>
